import { useEffect } from "react";
import { awsConfig } from "./aws-config";
import { savePushSubscription } from "./api";

function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function usePushNotifications() {
  useEffect(() => {
    async function register() {
      try {
        if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;
        const registration = await navigator.serviceWorker.register("/sw.js");
        await navigator.serviceWorker.ready;
        const existing = await registration.pushManager.getSubscription();
        if (existing) {
          await savePushSubscription(existing);
          return;
        }
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(awsConfig.vapidPublicKey)
        });
        await savePushSubscription(subscription);
        console.log("Push subscription saved");
      } catch (err) {
        console.error("Push registration failed:", err);
      }
    }
    register();
  }, []);
}
